import { metricNames } from '@linearb/linjs-common';
import {
  FreeTierGridItem,
  FreeTierLastInLineGridItem
} from '../AllContributorsDoraDashboard.style';
import NoPmToolWidget from './NoPmToolWidget';

const WIDGETS_DEFINITION = {
  DEPLOY_FREQUENCY: {
    name: 'Deploy Frequency',
    metricName: metricNames.RELEASES_COUNT,
    gridSize: 3,
    GridItem: FreeTierGridItem
  },
  MTTR: {
    name: 'MTTR',
    metricName: metricNames.PM_MTTR,
    gridSize: 1, // Custom - as 1.5 width
    GridItem: FreeTierGridItem
  },
  CFR: {
    name: 'CFR',
    metricName: metricNames.PM_CFR,
    gridSize: 1, // Custom - as 1.5 width
    GridItem: FreeTierLastInLineGridItem
  },
  PR_SIZE: {
    name: 'PR Size',
    metricName: metricNames.PR_SIZE,
    gridSize: 4,
    GridItem: FreeTierGridItem
  },
  MERGE_FREQUENCY: {
    name: 'Merge frequency',
    metricName: metricNames.PR_MERGED,
    gridSize: 4,
    GridItem: FreeTierGridItem
  },
  NO_PM_TOOL: {
    name: 'No pm tool',
    gridSize: 3,
    Component: () => <NoPmToolWidget />,
    GridItem: FreeTierLastInLineGridItem
  }
};

// eslint-disable-next-line jsdoc/require-returns
/**
 * @param {boolean} showWidgets should show PM tool/CFR & MTTR widgets
 */
export const getGroupWidgets = showWidgets => {
  return [
    WIDGETS_DEFINITION.DEPLOY_FREQUENCY,
    ...(showWidgets
      ? [WIDGETS_DEFINITION.MTTR, WIDGETS_DEFINITION.CFR]
      : [WIDGETS_DEFINITION.NO_PM_TOOL]),
    WIDGETS_DEFINITION.PR_SIZE,
    WIDGETS_DEFINITION.MERGE_FREQUENCY
  ];
};
